export const GET_VIEWER = `
	query GetViewer {
		viewer {
			id
			databaseId
			avatar {
				fileUrl
			}
			email
			name
			username
			permalink
			encryptionKey
			originGroup {
				id
				name
				scenarioRecipientGroups (first: 1000) {
					nodes {
						id
						name
					}
				}
			}
			organization {
				id
				databaseId
				name
				slug
				settings
				projects {
					permissions {
						canCreate {
							value
						}
						canIndex {
							value
						}
						canIndexInCreate {
							value
						}
					}
				}
			}
			licenses {
				nodes {
					id
					expiresAt
					type
					product
					state
				}
			}
			settings
	    wlcProfileSettings {
				id
				eulaVersionConfirmed      
	      lastLogin
	      projectListSeen
	      releaseNotesVersionSeen
	      wlcSettings
				serverOptions
	    }
		}
	}
`;